



















































import Vue from "vue";
import LayoutColumnSingle from "@/components/Atoms/Layout/ColumnSingle/index.vue";
import EventHeader from "@/components/Molecules/EventHeader/index.vue";
import TableField from "@/components/Atoms/Forms/TableField/index.vue";
import LoadingView from "@/components/Molecules/LoadingView/index.vue";
import EventExperienceDescriptiveQuestions from "./Molecules/EventExperienceDescriptiveQuestions/index.vue";
import EventExperienceReviews from "./Molecules/EventExperienceReviews/index.vue";
import EventExperienceReviewUser from "./Molecules/EventExperienceReviewUser/index.vue";
import EventExperienceSteps from "./Molecules/EventExperienceSteps/index.vue";
import ClipMixin from "@/components/Mixins/Clip/index";
import { CompanyDetailReviewCategory } from "@/api/types";

import { Data, Methods, Computed, Props } from "./types";
import { PropType } from "vue/types/umd";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "EventExperience",
  components: {
    EventHeader,
    TableField,
    EventExperienceDescriptiveQuestions,
    EventExperienceReviews,
    EventExperienceReviewUser,
    EventExperienceSteps,
    LayoutColumnSingle,
    LoadingView
  },
  mixins: [ClipMixin],
  props: {
    eventExperience: {
      type: Object as PropType<Props["eventExperience"]>,
      default: undefined
    },
    company: {
      type: Object as PropType<Props["company"]>,
      default: undefined
    },
    category: {
      type: String as PropType<Props["category"]>,
      default: undefined
    },
    graduateYear: {
      type: Number,
      required: true,
      default: 0
    },
    experienceReview: {
      type: Object as PropType<Props["experienceReview"]>,
      default: undefined
    },
    isLoading: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    formattedTableData() {
      if (!this.eventExperience) return;

      return this.eventExperience.experience_contents.table_contents.map(
        table_content => ({
          head: table_content.label,
          data: {
            type: "text",
            text: table_content.value
          }
        })
      );
    },
    formattedSteps() {
      if (!this.eventExperience) return;

      const { selection_report_items } = this.eventExperience.selection_report;

      if (!selection_report_items) {
        return;
      }

      const categories = Array.from(
        new Set(selection_report_items.map(e => e.category))
      );
      const steps = categories.map(categoryName => ({
        category: categoryName,
        selection_report_items: selection_report_items.filter(
          item => item.category === categoryName
        )
      }));

      return steps;
    },
    isSeminar() {
      return this.category === CompanyDetailReviewCategory.SEMINAR;
    }
  },
  methods: {
    toggleClipped(clipped) {
      if (!this.eventExperience) return;
      if (clipped) {
        // @ts-ignore
        (this as InstanceType<typeof ClipMixin>).createClip({
          event_detail_id: null,
          experience_id: this.eventExperience.id
        });
      } else {
        // @ts-ignore
        (this as InstanceType<typeof ClipMixin>).deleteClip({
          clip_id: this.eventExperience.clip_id!
        });
      }
    }
  }
});
